import ConfirmationModal from '@/components/molecules/ConfirmationModal';
import { useResendVerificationEmail } from '@/hooks/auth/resendVerificationEmail';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  email?: string | null;
};

const VerifyEmailConfirmationModal = ({ isOpen, onClose, email }: Props) => {
  const { mutate: resendVerificationEmail, isPending: isResendingVerificationEmail } =
    useResendVerificationEmail(onClose);

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title="Verify Your Email"
      description={`In order to apply for a creator role, you must first verify your email. Click the button below and we'll send an email to: ${email}`}
      confirmButtonText="Send verification email"
      confirmLoading={isResendingVerificationEmail}
      onConfirm={() => resendVerificationEmail()}
      verticalButtons
    />
  );
};

export default VerifyEmailConfirmationModal;
